import cn from '@/lib/cs';
import React from 'react';

const ShapesIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7 22 3 20.3 1 15.9l2-4L7 10l4.2 1.7 1.9 4.1-1.9 4.2-4.1 2Zm13.2-9.7-5.7-.1-2.4-1.3.4-2.7 2.8-5 2-1.4L19.8 3l2.7 5.1v2.7l-2.2 1.5Zm.1 10.7H17L14 20.1l.4-3.5 2.4-2.4 3.4-.1 2.7 2.5-.1 3.5-2.6 2.8ZM8.4 1l1 2 2.2.3.3 1L10.5 6l.2 2.1-.8.7-2-1-2 1-.8-.7.3-2.2-1.6-1.5.4-1.1L6.4 3l1-2h1Z"
		/>
	</svg>
);

export default ShapesIcon;
